<template>
  <section class="lottie-intro-ani-handler">
    <lottie
      ref="introLottie"
      class="lottie-intro-ani-handler__lottie-wrapper"
      v-on:animCreated="handleAnimation"
    ></lottie>
  </section>
</template>

<script>
import Lottie from '@/assets/vue-lottie';
import { mapState } from 'vuex';
export default {
  name: 'lottie-intro-ani-handler',
  components: {
    lottie: Lottie
  },
  props: ['animation', 'isMiddle'],
  data() {
    return {
      randomDelay: 0,
      timeOuts: []
    };
  },

  methods: {
    handleAnimation(anim) {
      this.anim = anim;
    },
    showIdleState() {
      this.anim.setDirection(-1);
      this.anim.play();
    },
    showActiveState() {
      this.anim.setDirection(1);
      this.anim.play();
    }
  },
  mounted() {
    this.defaultOptions = {
      renderer: 'svg',
      animationData: this.animation,
      autoplay: false,
      loop: false,
      rendererSettings: {
        progressiveLoad: true,
        clearCanvas: true,
        hideOnTransparent: true,
        className: this.isMiddle ? 'lottie-intro-middle' : `lottie-intro`
      }
    };

    this.$refs.introLottie.load(this.defaultOptions);
  },
  destroyed() {
    this.$destroy();
  }
};
</script>

<style lang="scss">
.lottie-intro-ani-handler {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  &__lottie-wrapper {
    width: 100%;
    height: 100%;
  }
  .lottie-intro {
    height: auto !important;
  }
  .lottie-intro-middle {
    height: 100% !important;
  }
}
</style>
